import { render, staticRenderFns } from "./LegalSentence.vue?vue&type=template&id=2cfa5eda&"
import script from "./LegalSentence.vue?vue&type=script&lang=js&"
export * from "./LegalSentence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports